export const filterId = 'wtfBytesToSize';

export const factory = () => {
    const myFunction = (bytes) => {
        let result = 'n/a';
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        if (bytes !== 0) {
            const i = Math.floor(Math.log(bytes) / Math.log(1024));
            result = `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
        }

        return result;
    };

    return myFunction;
};